import { useState } from "react";
import { createEntityStore } from "../../common/entityStore";
import { Button, Grid } from "@mui/material";
import { propFileField } from "../../common/entityStoreForm";
import { propRequired } from "../../common/entityStoreValidators";
import { PageTitle } from "../../layout/PageTitle";
import { EntityStoreSaveButton } from "../../common/SaveButton";
import { downloadFromApi } from "../../common/download";

export function SalesJournalSettingsPage() {
    const [useStore] = useState(() => createEntityStore<SalesJournalParams>({
        data: {},
        path: "settings/salesJournalSettings",
        fetchOnInit: false,
        onSaved(entity) {
            useStore.getState().setServerData(entity);
        },
        propValidators: [
            propRequired("file"),
        ]
    }));
    function download() {
        downloadFromApi(`settings/salesJournalSettings/file`);
    }
    return <>
        <PageTitle title="Sales journal settings" />
        <Grid container maxWidth="sm" columnSpacing={2} rowSpacing={2}>
            <Grid item xs={12}>{propFileField(useStore)("file", "File")}</Grid>
            <Grid item><EntityStoreSaveButton useStore={useStore} /></Grid>
            <Grid item><Button onClick={download}>Get current template</Button></Grid>
        </Grid>
    </>;
}

interface SalesJournalParams {
    file?: File;
}
